import { throttle } from 'throttle-debounce'

const isVisible = (el) => {
    const parent = el.parentElement

    if (!parent || window.getComputedStyle(parent).display === 'none') {
        return false
    }

    return true
}

export default () => ({
    mobileVideo: null,
    mobileVideoIsPlaying: false,
    mobileVideoIsMuted: true,
    desktopVideo: null,
    desktopVideoIsPlaying: false,
    desktopVideoIsMuted: true,

    toggleMobileVideo() {
        const video = this.mobileVideo

        if (video) {
            if (video.paused) {
                video.play()
            } else {
                video.pause()
            }
        }
    },

    toggleMobileAudio() {
        const video = this.mobileVideo

        if (video) {
            video.muted = !video.muted
        }
    },

    toggleDesktopVideo() {
        const video = this.desktopVideo

        if (video) {
            if (video.paused) {
                video.play()
            } else {
                video.pause()
            }
        }
    },

    toggleDesktopAudio() {
        const video = this.desktopVideo

        if (video) {
            video.muted = !video.muted
        }
    },

    init() {
        this.mobileVideo = this.$el.querySelector(
            '[data-ref="mobileVideo"] video'
        )
        this.desktopVideo = this.$el.querySelector(
            '[data-ref="desktopVideo"] video'
        )

        if (this.mobileVideo) {
            this.mobileVideo.addEventListener(
                'play',
                () => (this.mobileVideoIsPlaying = true)
            )
            this.mobileVideo.addEventListener(
                'pause',
                () => (this.mobileVideoIsPlaying = false)
            )
            this.mobileVideo.addEventListener(
                'volumechange',
                () => (this.mobileVideoIsMuted = this.mobileVideo.muted)
            )
        }

        if (this.desktopVideo) {
            this.desktopVideo.addEventListener(
                'play',
                () => (this.desktopVideoIsPlaying = true)
            )
            this.desktopVideo.addEventListener(
                'pause',
                () => (this.desktopVideoIsPlaying = false)
            )
            this.desktopVideo.addEventListener(
                'volumechange',
                () => (this.desktopVideoIsMuted = this.desktopVideo.muted)
            )
        }

        window.addEventListener(
            'resize',
            throttle(200, () => {
                if (this.mobileVideo) {
                    if (!isVisible(this.mobileVideo)) {
                        this.mobileVideo.muted = true
                    }
                }

                if (this.desktopVideo) {
                    if (!isVisible(this.desktopVideo)) {
                        this.desktopVideo.muted = true
                    }
                }
            })
        )
    },
})
